import { render, staticRenderFns } from "./CommonTemplates.vue?vue&type=template&id=37e536be&"
import script from "./CommonTemplates.vue?vue&type=script&lang=js&"
export * from "./CommonTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports